'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unify = unify;
exports.unifyAll = unifyAll;
exports.intersect = intersect;
exports.intersectAll = intersectAll;
exports.negate = negate;
exports.subtract = subtract;
exports.timeRangesOfIntersection = timeRangesOfIntersection;
exports.addBufferTime = addBufferTime;
exports.getBufferTimeRanges = getBufferTimeRanges;
exports.getMeetingLengthStartTimes = getMeetingLengthStartTimes;
exports.roundTimeUp = roundTimeUp;
exports.getFifteenMinuteStartTimes = getFifteenMinuteStartTimes;

var _Immutable = require('Immutable');

var _identity = require('transmute/identity');

var _identity2 = _interopRequireDefault(_identity);

var _TimeRange = require('MeetingsBase/models/TimeRange');

var _TimeRange2 = _interopRequireDefault(_TimeRange);

var _dates = require('MeetingsBase/constants/dates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function unify(listTimeRanges) {
  return listTimeRanges.sort(function (x, y) {
    return x.start - y.start;
  }).reduce(function (xs, x) {
    return xs.butLast().concat(xs.size && xs.last().union(x) || [x]);
  }, (0, _Immutable.List)());
}

function unifyAll() {
  for (var _len = arguments.length, arrTimeRanges = Array(_len), _key = 0; _key < _len; _key++) {
    arrTimeRanges[_key] = arguments[_key];
  }

  return unify((0, _Immutable.List)(arrTimeRanges).flatten(true));
}

function intersect(listTimeRangesA, listTimeRangeB) {
  return listTimeRangesA.map(function (timeRangeA) {
    return listTimeRangeB.map(function (timeRangeB) {
      return timeRangeB.intersect(timeRangeA);
    }).filter(function (x) {
      return x !== null;
    });
  }).flatten(true);
}

function intersectAll(listTimeRangesA, listTimeRangesB) {
  if (!listTimeRangesA) {
    return (0, _Immutable.List)();
  }
  if (listTimeRangesA && !listTimeRangesB) {
    return unify(listTimeRangesA);
  }

  var intersection = intersect(listTimeRangesA, listTimeRangesB);

  for (var _len2 = arguments.length, restArr = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    restArr[_key2 - 2] = arguments[_key2];
  }

  if (restArr.length === 0) {
    return intersection;
  }
  return intersectAll.apply(undefined, [intersection, restArr[0]].concat(_toConsumableArray(restArr.slice(1))));
}

function negate(listTimeRanges) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;

  return listTimeRanges.sort(function (x, y) {
    return x.start - y.start;
  }).reduce(function (acc, timeRange) {
    return (acc.butLast() || (0, _Immutable.List)()).push(acc.last().set('end', timeRange.start)).push(acc.last().set('start', timeRange.end));
  }, (0, _Immutable.List)([_TimeRange2.default.from({ start: start, end: end })])).filter(function (timeRange) {
    return timeRange.start < timeRange.end;
  });
}

function subtract(listTimeRangesA, listTimeRangesB) {
  return intersect(listTimeRangesA, negate(listTimeRangesB));
}

function timeRangesOfIntersection(timeRange, listTimeRanges) {
  /**
     * Returns the TimeRanges in listTimeRanges that intersect with timeRange
     * @param {TimeRange} timeRange - The timeRange to check intersections against
     * @param {List} listTimeRanges - A list of TimeRanges where intersections
     * can occur
     * @return {List} A List of TimeRanges filtered from listTimeRanges that
     * intersect with the timeRange specified in the first parameter
     */
  return listTimeRanges.reduce(function (acc, value) {
    return value.hasIntersection(timeRange) ? acc.push(value) : acc;
  }, (0, _Immutable.List)());
}

function addBufferTime(listTimeRanges, bufferTime) {
  return listTimeRanges.map(function (timeRange) {
    return _TimeRange2.default.from({
      start: timeRange.start - bufferTime,
      end: timeRange.end + bufferTime
    });
  });
}

function getBufferTimeRanges(busyTimeRange, bufferTime) {
  return (0, _Immutable.List)([_TimeRange2.default.from({
    start: busyTimeRange.start - bufferTime,
    end: busyTimeRange.start
  }), _TimeRange2.default.from({
    start: busyTimeRange.end,
    end: busyTimeRange.end + bufferTime
  })]);
}

function getMeetingLengthStartTimes(listTimeRanges, duration) {
  /**
     * @deprecated
     * @param {List(TimeRange)} listTimeRanges Time ranges to find start times in
     * @param {milliseconds} duration The meeting length in milliseconds
     * @returns {List(timestamp)} All timestamps, at which meetings of the given
     * duration can start and will have time to run to completion, with start times
     * spaced by the length of 'duration'
     */
  return listTimeRanges.map(function (timeRange) {
    return timeRange.toBlocks(duration);
  }).flatten(true).map(function (timeRange) {
    return timeRange.start;
  }).toSet().toList();
}

function getPossibleStartTimes(timeRange, interval /* millis */) {
  return (0, _Immutable.Range)(0, Math.ceil(timeRange.duration() / interval)).map(function (i) {
    return timeRange.start + i * interval;
  });
}

function roundTimeUp(time, roundTo /* millis */) {
  /**
   * @param {int} time A time to round, in milliseconds
   * @param {int} roundTo The interval to which to round the nearest time up
   * @returns {int} The time, rounded up to the nearest roundTo interval
   * Example: 9:15, rounded up to the nearest 10 minute interval: 9:20
   */
  return Math.ceil(time / roundTo) * roundTo;
}

function roundStartTime(timeRange, roundTo /* millis */) {
  var roundedStartTime = roundTimeUp(timeRange.start, roundTo);
  return timeRange.clipStart(roundedStartTime);
}

function getStartTimesForRange(timeRange, duration) {
  /**
   * @param {TimeRange} timeRange Time range to convert to regular start times
   * @param {milliseconds} duration The meeting length in milliseconds
   * @returns {List(timestamp)} All timestamps, at clean 15-minute intervals
   * (:00, :15, :30, :45) at which meetings of the given duration can start
   * and will have time to run to completion
   */
  return getPossibleStartTimes(timeRange, _dates.FIFTEEN_MINUTE_MILLIS).filter(function (startTime) {
    return timeRange.end - startTime >= duration;
  });
}

function getFifteenMinuteStartTimes(listTimeRanges, duration) {
  /**
   * @param {List(TimeRange)} listTimeRanges Time ranges to convert to start times
   * @param {milliseconds} duration The meeting length in milliseconds
   * @returns {List(timestamp)} All timestamps, at clean 15-minute intervals
   * (:00, :15, :30, :45) at which meetings of the given duration can start
   * and will have time to run to completion
   */
  return listTimeRanges.map(function (timeRange) {
    return roundStartTime(timeRange, _dates.FIFTEEN_MINUTE_MILLIS);
  }).filter(_identity2.default).map(function (timeRange) {
    return getStartTimesForRange(timeRange, duration);
  }).flatten(true).toSet().toList();
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/utils/TimeRangeListUtils.js
// module id = 87
// module chunks = 0